// extracted by extract-css-chunks-webpack-plugin
module.exports = {"amount":"apple-payment-method__amount___356Ww","major":"apple-payment-method__major___b7al9","currency-symbol":"apple-payment-method__currency-symbol___36yAU","currencySymbol":"apple-payment-method__currency-symbol___36yAU","title":"apple-payment-method__title___3oj3J","fees":"apple-payment-method__fees___1lkn9","description":"apple-payment-method__description___3nOV_"};
    if(module.hot) {
      // 1747359191927
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  